<script lang="ts">
    import { applyAction } from '$app/forms';
    import { beforeNavigate } from '$app/navigation';
    import { page } from '$app/stores';
    import { isTestOnlyRoute } from '$src/lib/services/routing/test-routes';
    import { get } from 'svelte/store';

    beforeNavigate(async ({ to, cancel }) => {
        const { isCasumoProd, isCasumoProdEnforced } = get(page).data;
        const isProd = isCasumoProd || isCasumoProdEnforced;
        if (to && isProd && isTestOnlyRoute(to.url.pathname, $page.data.market)) {
            cancel();
            applyAction({
                type: 'error',
                error: {
                    message: 'Not found',
                    errorId: '404-NOT-FOUND'
                }
            });
        }
    });
</script>
